import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ColumnFormat } from '/@/modules/core/app/constants/data.constants';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import NumeralService from '/@/modules/core/app/services/NumeralService';
import dayjs from 'dayjs';

export class EstateBankingAccount extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {number}
   */
  amount;

  /**
   * @var {number}
   */
  currencyId;

  /**
   * @var {number}
   */
  createdByUserId;

  /**
   * @var {number}
   */
  estateId;

  /**
   * @var {string}
   */
  createdAt;

  /**
   * @var {string}
   */
  updatedAt;

  /**
   * @relationship
   * @var {?FinancialAccount}
   */
  financialAccount;

  /**
   * @relationship
   * @var {?Currency}
   */
  currency;

  constructor(model = {}) {
    super(model);
    super.setRelationships(this, model, this.getModelName());

    this.id = model.id;
    this.name = model.name;
    this.amount = model.amount;
    this.currencyId = model.currencyId;
    this.createdByUserId = model.createdByUserId;
    this.estateId = model.estateId;
    this.createdAt = model.createdAt;
    this.updatedAt = model.updatedAt;
  }

  /**
   *
   * @returns {string}
   */
  getModelName() {
    return ModelType.ESTATE_BANKING_ACCOUNT;
  }

  /**
   * @returns {string}
   */
  get displayValue() {
    return NumeralService.formatValue(this.amount, ColumnFormat.FORMAT_CURRENCY, 2);
  }

  /**
   * @returns {string}
   */
  get updatedAtFromNow() {
    return dayjs(this.updatedAt).fromNow();
  }
}
